export default {
  state: {
    refush: ""
  },
  mutations: {
    changeRefush(state, value) {
      state.refush = value
    }
  }
}